import { Component } from '@angular/core';
import {DashboardAdvogado} from "../../../../modules/home/models/dashboardAdvogado";
import {Token} from "../../../../modules/auth/models/token";
import {AuthService} from "../../../../modules/auth/services/auth-service";
import {DashboardService} from "../../../../modules/gestao/services/dashboard.service";
import {ToastrService} from "ngx-toastr";
import {Evento} from "../../calendario/models/evento";
import {AtendimentoService} from "../../../../modules/cadastro/services/atendimento.service";
import {AtendimentoDashboardCrm} from "../../../../modules/cadastro/models/atendimento-dashboard-crm";

@Component({
    selector: 'app-dashboard-advogado',
    templateUrl: './dashboard-advogado.component.html',
    styleUrl: './dashboard-advogado.component.css',
    standalone: false
})
export class DashboardAdvogadoComponent {
  dashboard = new DashboardAdvogado();
  token: Token | undefined;
  usuario = "";
  numeroCadastrosNovos = 1;

  constructor(private tokenService: AuthService,
              private dashboardService: DashboardService) {
    this.token = this.tokenService.AccessToken;
    this.buscarDashboard();
    this.usuario = this.token?.nome ?? '';
  }

  private buscarDashboard(){
    this.dashboardService.buscarDashboardCRM().subscribe(response =>{
      if(response.sucesso){
        this.dashboard = response.dados;
      }
    });
  }
}
